import { useContext } from 'react';
import { DictionariesContext } from '@/creditflowresearch/application/Dictionaries/DictionariesContext';
import type { IDictionarySector } from '@/creditflowresearch/domain/vo/IDictionary';
import { useHeaderMenuContext } from './HeaderMenuContext';

const useMappedSectors = (): Record<string, IDictionarySector> => {
  const legacy = useContext(DictionariesContext);
  const { mappedSectors } = useHeaderMenuContext();

  return (legacy?.sectorsList ?? mappedSectors) as Record<string, IDictionarySector>;
};

export default useMappedSectors;
